// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const canvasRoll = defineModel({
  id: "canvas-roll",
  batchId: "future",
  name: "Canvas roll",
  tags: ["scenery","canvas","roll","low-poly","age-of-mcp","future"],
  summary: "Rolls of heavy canvas — sails, tents, tarpaulins and sacks.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.42,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.6, 0.04, 0.34), color: "#9a7544", position: [0, 0.02, 0] },
      { geometry: new THREE.CylinderGeometry(0.13, 0.13, 0.5, 12), color: "#d8cdb2", position: [-0.12, 0.17, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.TorusGeometry(0.1326, 0.012, 5, 12), color: "#8a6a3a", position: [-0.12, 0.17, 0.12], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.13, 0.13, 0.5, 12), color: "#cabf9f", position: [0.13, 0.17, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.TorusGeometry(0.1326, 0.012, 5, 12), color: "#8a6a3a", position: [0.13, 0.17, 0.12], rotation: [1.570796, 0, 0] },
    ],
  animations: [],
});
